export const ConfigData = [
  {
    id: "submission_no",
    name: "Submission No.",
    isShow: true,
    width: "200px",
    filter: true,
  },
  {
    id: "related_to",
    name: "What's your concern related to",
    isShow: true,
    width: "300px",
    filter: true,
  },

  {
    id: "created_on",
    name: "Submitted On",
    isShow: true,
    width: "200px",
    filter: false,
    format: "date-time",
  },
  {
    id: "created_by.name",
    name: "Created By",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "120px",
    filter: true,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Update Status", "View Details"],
     permission: {
      ["View Details"]: {
        id: "View Details",
        permission: ["hr_connect.access_employee_concern"]
      },
      ["Update Status"]: {
        id: "Update Status",
        permission: ["hr_connect.update_status_employee_concern"],
      },
    },
    isshowAction: {
      item: "status",
      children: [
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: 'closed',
        }
      ],
    },
  },
];

export const dropdownConfig = [];

export const statusConfig = [
  "Submitted",
  "Investigating",
  "Closed"
];

export const DefaulSorting = {
  id: "created_on",
  name: "Created On",
  isShow: true,
  width: "160px",
  filter: true,
};